import React from 'react'

import { 
    useFormContext, 
    useFieldArray,
    useWatch 
} from 'react-hook-form'

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    ApplicationHeader,
    InputField,
    AddButtonDiv, 
    DeleteButtonDiv, 
    AddButton, 
    DeleteButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux";

function LinkSection(props) {

    const { register, control, errors } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        control,
        name: "additional_links"
    })

    const links = useWatch({
        control,
        name: 'additional_links'
    })

    const locked = useSelector(state => state.appViewer.locked)

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Additional Links</SectionHeader>
            </HeaderDiv>
            {fields.map((item, index) => {
                return (
                    <FormDiv className="additional-link-form" key={item.id}>
                        <form>
                            <ApplicationRowDiv>
                                <LeftApplicationDiv>
                                    <ApplicationHeader>Name<RedTint>*</RedTint></ApplicationHeader>
                                    <InputField 
                                        type="text" name={`additional_links[${index}].name`} placeholder="Link Name"
                                        ref={
                                            register({
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: 'exceeds 50 character limit'
                                                },
                                                pattern: {
                                                    value: /^[a-zA-Z0-9 ,/()#&\+\-\.;:]+$/,
                                                    message: 'invalid character usage'
                                                }
                                            })
                                        }  
                                        defaultValue={item.name}
                                        readOnly = {locked}
                                    />
                                    {errors['additional_links'] != null && errors['additional_links'][index] != null && errors['additional_links'][index]['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['additional_links'][index]['name']['message']}</ErrorText>}
                                </LeftApplicationDiv>
                                <RightApplicationDiv>
                                    <ApplicationHeader>URL</ApplicationHeader>
                                    <InputField 
                                        type="text" name={`additional_links[${index}].link`} placeholder="Link URL"
                                        ref={
                                            register({
                                                maxLength: {
                                                    value: 2048,
                                                    message: 'exceeds 2048 character limit'
                                                },
                                                pattern: {
                                                    value: /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9\-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9\-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/,
                                                    message: 'invalid format or character usage'
                                                }
                                            })
                                        }
                                        defaultValue={item.link}
                                        readOnly = {locked}
                                    />
                                    {errors['additional_links'] != null && errors['additional_links'][index] != null && errors['additional_links'][index]['link'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['additional_links'][index]['link']['message']}</ErrorText>}
                                </RightApplicationDiv>
                            </ApplicationRowDiv>
                            {fields.length !== 0 && !locked ? 
                                <DeleteButtonDiv>
                                    <DeleteButton type="button" onClick={() => remove(index)}>Delete</DeleteButton>
                                </DeleteButtonDiv> : null
                            }
                        </form>
                    </FormDiv>
                );
            })}
            {!locked ?
                <AddButtonDiv>
                    <AddButton type="button" onClick={() => {append({link: ""})}}>Add Link</AddButton> 
                </AddButtonDiv> : null
            }
        </SectionDiv>
    );
}

export default LinkSection;